var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.8859 21.0006C41.8859 32.5375 32.5336 41.89 20.9968 41.89C9.45984 41.89 0.107422 32.5375 0.107422 21.0006C0.107422 9.46375 9.45984 0.111328 20.9968 0.111328C32.5335 0.111328 41.8859 9.46375 41.8859 21.0006Z",
    fill: "#00A478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8551 20.6352V16.9807H13.8984V13.7773H27.7492V17.0258H22.7926V20.6352H18.8551Z",
    fill: "#00A478"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7676 21.0408C11.7676 19.8227 15.7514 18.8301 20.708 18.8301C25.6646 18.8301 29.6485 19.8227 29.6485 21.0408C29.6485 22.259 25.6646 23.2516 20.708 23.2516C15.7514 23.2516 11.7676 22.259 11.7676 21.0408ZM28.9073 21.0408C28.583 20.5896 25.8963 19.191 20.708 19.191C15.5198 19.191 12.833 20.5445 12.5088 21.0408C12.833 21.492 15.5198 22.1688 20.708 22.1688C25.9426 22.1688 28.583 21.492 28.9073 21.0408Z",
    fill: "#00A478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7935 21.7633V19.2367C22.145 19.1916 21.4501 19.1465 20.7553 19.1465C20.1068 19.1465 19.5045 19.1465 18.9023 19.1916V21.7182C19.4582 21.7182 20.1068 21.7633 20.7553 21.7633C21.4501 21.8084 22.145 21.8084 22.7935 21.7633Z",
    fill: "#00A478"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7084 23.2523C20.0599 23.2523 19.4577 23.2523 18.8555 23.2072V29.9297H22.7466V23.1621C22.0981 23.2072 21.4033 23.2523 20.7084 23.2523Z",
    fill: "#00A478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTet);
export default __webpack_public_path__ + "static/media/tet.5e70291151453bf03b2a2fa77828ea30.svg";
export { ForwardRef as ReactComponent };